/**
 * schemas.ts — Zod schemas ที่ web/api ใช้ร่วมกัน (contract เดียว, T036)
 */
import { z } from 'zod';
import { toDecimal } from './money.js';

/** จำนวนเงินเป็น string ที่ parse เป็น Decimal ได้ (ห้าม float) */
export const moneyString = z
  .string()
  .trim()
  .min(1, 'กรอกจำนวนเงิน')
  .refine((v) => {
    try {
      toDecimal(v);
      return true;
    } catch {
      return false;
    }
  }, 'จำนวนเงินไม่ถูกต้อง');

/** วันที่รูปแบบ YYYY-MM-DD */
export const dateKey = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'วันที่ต้องเป็นรูปแบบ YYYY-MM-DD');

export const uuid = z.string().uuid('รหัสไม่ถูกต้อง');

export const salesChannelCode = z.enum([
  'tiktok_shop',
  'shopee',
  'lazada',
  'facebook',
  'line',
]);
export type SalesChannelCode = z.infer<typeof salesChannelCode>;

/** query scope กิจการ/ร้าน (ค่าเหล่านี้ยังต้อง resolve membership ฝั่ง server) */
export const tenantQuery = z.object({
  accountId: uuid,
  businessId: uuid.optional(),
});
export type TenantQuery = z.infer<typeof tenantQuery>;

/** ช่วงวันรายงาน */
export const dateRange = z
  .object({ from: dateKey, to: dateKey })
  .refine((r) => r.from <= r.to, { message: 'ช่วงวันที่ไม่ถูกต้อง', path: ['to'] });

export const granularity = z.enum(['day', 'week', 'month', 'year']);

export const pagination = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

/** สมัครใช้งานเอง: สร้างกิจการ + ร้านแรก */
export const onboardingInput = z.object({
  accountName: z.string().trim().min(1, 'กรอกชื่อกิจการ/บริษัท').max(120),
  businessName: z.string().trim().min(1, 'กรอกชื่อร้าน').max(120),
});
export type OnboardingInput = z.infer<typeof onboardingInput>;
